module.exports = __webpack_public_path__ + "fonts/Clash-Light.de23e71.woff";